import { SECTIONS } from './tech-due-diligence-quiz.data';

export const TOTAL_QUESTIONS = SECTIONS.reduce((sum, section) => sum + section.questions.length, 0);
